<template>
    <div class="mine-content">
        <div class="mine-header"><span @click="util.goblack()" class="back"><img src="@/assets/images/base/icon_righ_g.png"/></span>Personals</div>
        <div class="second-pard">
          <ul @click="util.topage('/avater')">
              <li><img src="@/assets/images/user/mine/portraitmode_woman_5210.png"/></li>
              <li>Avatar</li>
              <li><img :src="userInfo.ico_picture_img"/></li>
              <li><img src="@/assets/images/base/icon_righ_g.png"/></li>
            </ul>  
            <!-- <ul @click="util.topage('/updateuser/nick_name')">
              <li><img src="@/assets/images/user/mine/user-info_73114.png"/></li>
              <li>Nickname</li>
              <li>{{userInfo.nick_name}}</li>
              <li><img src="@/assets/images/base/icon_righ_g.png"/></li>
            </ul> -->
            <!-- <ul @click="util.topage('/updateuser/phone')">
              <li><img src="@/assets/images/user/mine/telephone-1_icon-icons.com_65082.png"/></li>
              <li>UserName</li>
              <li>{{userInfo.phone}}</li>
              <li><img src="@/assets/images/base/icon_righ_g.png"/></li>
            </ul> -->
            <ul>
              <li><img src="@/assets/images/user/mine/telephone-1_icon-icons.com_65082.png"/></li>
              <li>Username</li>
              <li>{{userInfo.phone}}</li>
              <li><img src="@/assets/images/base/icon_righ_g.png"/></li>
            </ul>
            <ul @click="opensexpage">
              <li><img src="@/assets/images/user/mine/ic_sex.png"/></li>
              <li>Gender</li>
              <li v-if="userInfo.sex==1">Male</li>
              <li v-if="userInfo.sex==2">Female</li>
              <li v-if="userInfo.sex==3">Confidential</li>
              <li><img src="@/assets/images/base/icon_righ_g.png"/></li>
            </ul>
            <!-- <ul @click="util.topage('/updateuser/email')">
              <li><img src="@/assets/images/user/mine/email_mail_4598.png"/></li>
              <li>Email</li>
              <li>{{userInfo.email}}</li>
              <li><img src="@/assets/images/base/icon_righ_g.png"/></li>
            </ul> -->
            <ul @click="util.topage('/updateuser/remark')">
              <li><img src="@/assets/images/user/mine/message_105089.png"/></li>
              <li>Signature</li>
              <li class="signature">{{userInfo.remark.slice(0,48)}}{{userInfo.remark.length >24?'...':''}}</li>
              <li><img src="@/assets/images/base/icon_righ_g.png"/></li>
            </ul>
        </div>
        <div v-show="showSex" class="van-popup van-popup--bottom" v-cloak>
          <p class="personalvantp" @click="tabSex(1)">Male</p>
          <p class="personalvantp" @click="tabSex(2)">Female</p>
          <p class="personalvantp" @click="tabSex(3)">Confidential</p>
          <p class="personalvantp cancelbtn" @click="tabSex(4)">Cancel</p>
        </div>
        <van-loading
        v-show="showloding"
        size="50px"
        color="#1989fa"
        vertical/>
    </div>
    </template>
    <script>
    /*global mui*/
    import Vue from "vue";
    import { Loading } from "vant";
    Vue.use(Loading);
    export default {
      data() {
        return {
          userInfo:this.util.user,
          showSex: false,
          showloding:false,
          fieldKey:"",
          fieldValue:"",
        };
      },
      methods:{
        opensexpage() {
          this.showSex = !this.showSex;
        },
        tabSex(num) {
          if (num == 4) {
            this.showSex = false;
          } else if (!this.showloding) {
            this.fieldKey = "sex";
            this.fieldValue = num;
            this.saveInfo();
          }
        },
        saveInfo(){
          let params = {fieldKey:this.fieldKey,fieldValue:this.fieldValue};
          this.util.setDnValueUser(params);
          this.axios.post(this.api.api_updateUserInfo, this.util.encodeSearchParams(params)).then(res => {
              this.showloding = false;
              if (res.data.code == 0) {
                this.userInfo[this.fieldKey] = this.fieldValue;
                this.showSex = false;
                mui.toast("Modification succeeded");
              } else {
                mui.toast(res.data.message);
              }
            })
            .catch(() => {
              this.showloding = false;
              mui.toast("Modification failed");
            });
        },
      },
      activated(){
        if (!this.util.isLogin()) this.util.topage('login');
        this.util.refreshUserInfo((res)=>this.userInfo = res);
      }
    };
    </script>
    <style lang="scss" scoped>
    .mine-content{
      font-size: 0.34rem;
      background: rgb(235, 235, 235);
      color:rgb(103, 103, 103);
      width: 100%;
      height: 100%;
      .mine-header{
        color:black;
        font-weight: bold;
        height: 1.2rem;
        display: grid;
        grid-template-columns: 20% 1fr 20%;
        align-items: center;
        text-align: center;
        .back{
          cursor: pointer;
          img{
            display: block;
            margin-left: 5%;
            width: 0.5rem;
            transform: rotate(180deg);
          }
        }
      }
      .second-pard{
        background: white;
        ul{
          display: grid;
          grid-template-columns: 12% 2.4rem 1fr 12%;
          border-bottom: 1px solid rgb(238, 238, 238);
          cursor: pointer;
          li{
            display: flex;
            align-items: center;
            height: 1.2rem;
            font-size: 0.34rem;
          }
          .signature{
            text-align: left;
          }
          :nth-child(1){
            margin-left: 20%;
            margin-right: auto;
            img{
              display: block;
              margin: auto;
              width:0.6rem;
            }
          }
          :nth-child(3){
            margin-left: auto;
            img{
              border-radius: 100%;
              display: block;
              width:1rem;
            }
          } 
          :nth-child(4){
            img{
              display: block;
              margin: auto;
              width:0.5rem;
            }
          }
        }
      }
      .van-popup--bottom {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        padding: 0 0.5rem;
        background: #fff;
        .personalvantp {
          width: 100%;
          text-align: center;
          height: 0.7rem;
          font-size: 0.34rem;
          line-height: 0.7rem;
          border: 1px solid #666;
          color: #333;
          border-radius: 0.4rem;
          margin: 0.3rem 0;
        }
        .cancelbtn{
          background:  #e4b6b6;
        }
      }
    }
    </style>  